'use client';
import { useCallback, useEffect, useState } from 'react';
import styles from './Popup.module.css';
import { Trash, TriangleAlert, X } from 'lucide-react';

const ConfirmPopup = (props : any) => {
    const [show, setShow] = useState(true);

    const closeHandler = useCallback(() => {
        setShow(false);
    }, []);

    useEffect(() => {
        document.body.addEventListener('keyup', function(e) {
            if (e.key == "Escape") {
                closeHandler()
            }
        });
    }, [closeHandler]);

    return (
        <>
            <div className={`${`${styles.popup_wrapper} px_confirm_wrapper`}`}>
                <div className={`${styles.popup_inner} px_confirm_inner`} style={{maxWidth : (props.maxWidth?props.maxWidth:'') }}>
                    <div className={`${styles.popup_close} px_confirm_cancel`} onClick={closeHandler}><X /></div>
                    <div className='px_confirm_icon'>
                        <span className='px_confirm_icon_delete'><Trash strokeWidth={1} /></span>
                        <span className='px_confirm_icon_info'><TriangleAlert strokeWidth={1} /></span>
                    </div>
                    <div className={`${styles.popup_heading_wrapper} text-center !mt-4`}>
                        <div className={`${styles.popup_heading} px_confirm_heading !p-0 !text-2xl`}>Are you sure?</div>
                        <div className={`${styles.popup_subheading} px_confirm_subheading`}>You want to delete this item.</div>
                    </div>
                    <div className="flex items-center justify-center gap-2 mb-4">
                        <button className='px_btn px_btn_outline px_confirm_cancel'>Cancel</button>
                        <button className='px_btn px_confirm_submit'>Delete</button>
                    </div>
                </div>
                <div className={`${styles.popup_overlay_close} px_confirm_cancel`} onClick={closeHandler}></div>
            </div>
        </>
    );
}

export default ConfirmPopup;